import { useEffect, useState } from 'react';
import '/assets/styles/pages/menu-product.scss';

// Sections
import PageHeader from '/views/sections/page-header';

// Partials
import Btn from '/views/partials/btn';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Placeholder from '/views/partials/placeholder';
import Pricebox from '/views/partials/pricebox';
import BasketControls from '/views/sections/basket-controls';

// Services
import menuServices from '/services/menu';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useTranslation } from '/utilities/i18n';

const MenuProduct = () => {
	const { id: productId } = useParams('menuProduct');
	const { branchTableTitle } = useBranchSelection();
	const { openModal } = useModals();
	const { t } = useTranslation();

	const [product, setProduct] = useState(null);

	useEffect(() => {
		if (productId) {
			menuServices
				.getMenuProduct(productId)
				.then(setProduct)
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	}, [productId]);

	return (
		<>
			<PageHeader
				icon="menu"
				backLink={product?.category?.id ? 'menuCategory' : 'home'}
				backLinkParams={product?.category?.id ? { id: product.category.id } : undefined}
				backLinkRedirect
				title={product?.category?.title ?? t('Ürün Detayı')}
				backLinkText
				subtitle={branchTableTitle}
			/>
			{product ? (
				<>
					<Img src={product.image} className="product-image" />

					<div className="product-titlewrap">
						<div className="wrapper">
							<h1 className="product-title">{product.title}</h1>
							{!!product.description?.length && (
								<div className="product-description">{product.description}</div>
							)}
						</div>
					</div>

					<Pricebox colored className="product-price" product={product} />

					{!!product.available_hours && (
						<div className="product-availability">
							<div className="wrapper">
							<span dangerouslySetInnerHTML={{ __html: t('Bu ürün <strong>{{hours}}</strong> saatleri arasında satılmaktadır.', { hours: product.available_hours }) }} />
							</div>
						</div>
					)}

					{!!product.allergen && (
						<div className="product-allergens">
							<div className="wrapper">
								{!!product.allergen?.keywords?.length && (
									<>
										<strong className="allergens-title">{t('Alerjenler')}</strong>
										<ul className="allergens-list">
											{product.allergen.keywords.map((keyword, nth) => (
												<li className="list-keyword" key={nth}>
													<Img className="keyword-image" src={keyword.image} alt={keyword.title} />
												</li>
											))}
										</ul>
									</>
								)}
								{!!product.allergen.description && (
									<div
										className="allergens-description wysiwyg"
										dangerouslySetInnerHTML={{ __html: product.allergen.description }}
									/>
								)}
							</div>
							<div className="product-nutrition">
								<Btn
									className="nude primary hyperlink"
									onClick={() => {
										openModal('productNutritionValues')
									}}>
									{t('Besin Değerleri')}
								</Btn>
							</div>
						</div>
					)}
					<BasketControls product={product} />
				</>
			) : (
				<>
					<Placeholder className="product-image" />
					<div className="product-titlewrap">
						<div className="wrapper">
							<Placeholder className="product-title" />
							<Placeholder className="product-description" />
						</div>
					</div>

					<Pricebox colored className="product-price" price={false} />
				</>
			)}
		</>
	);
};

export default MenuProduct;
